import ko from 'knockout';
import MicroModal from 'micromodal';
import { CreateMeetingWithNemIdViewModel } from './create-meeting-with-nemid-view-model';
import { CreateMeetingWithoutNemIdViewModel } from './create-meeting-without-nemid-view-model';

class CreateMeetingModalViewModel {
	public activeTab = ko.observable('without-nemid');

	public withNemIdViewModel = new CreateMeetingWithNemIdViewModel();
	public withoutNemIdViewModel = new CreateMeetingWithoutNemIdViewModel();

	public showNavigation = ko.pureComputed(() => {
		const isSuccess =
			this.withNemIdViewModel.success() || this.withoutNemIdViewModel.success();
		return !isSuccess;
	});

	public isSubmitting = ko.pureComputed(() => {
		return (
			this.withNemIdViewModel.isSubmitting() ||
			this.withoutNemIdViewModel.isSubmitting()
		);
	});

	public showModal = (): void => {
		(document.activeElement as HTMLElement).blur();
		this.withNemIdViewModel.reset();
		this.withoutNemIdViewModel.reset();
		MicroModal.show('create-meeting-modal', {
			awaitCloseAnimation: true,
			disableFocus: true,
		});
	};

	public setActiveTab = (tab: string): void => {
		this.activeTab(tab);
	};
}

export function CreateMeeting(rootNode: HTMLElement): void {
	ko.applyBindings(new CreateMeetingModalViewModel(), rootNode);
}
